import { Box, Button, Divider, IconButton, Popover, Typography } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import HelpOutline from "@mui/icons-material/HelpOutline";
import Key from "@mui/icons-material/Key";
import Logout from "@mui/icons-material/Logout";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useCurrentUser } from "./CurrentUser";

// UserMenu shows who is signed in and holds the account actions that don't
// belong in the nav, so the toolbar keeps a single icon instead of a row of them.
// onHelp opens the shortcuts and tips; the admin account has none
export function UserMenu(props: { onHelp?: () => void }) {
    const anchor = useRef<HTMLButtonElement>(null);
    const [open, setOpen] = useState(false);
    const user = useCurrentUser();

    const name = [user?.firstName, user?.lastName].filter(v => !!v).join(" ");

    return (
        <>
            <IconButton
                ref={anchor}
                color="inherit"
                edge="end"
                size="small"
                aria-haspopup="dialog"
                aria-expanded={open}
                aria-label="Account"
                onClick={() => setOpen(true)}
            >
                <AccountCircle fontSize="small" />
            </IconButton>

            <Popover
                open={open}
                anchorEl={anchor.current}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Box sx={{ minWidth: 200, maxWidth: 280 }}>
                    <Box sx={{ px: 2, py: 1.5 }}>
                        <Typography variant="body2" noWrap sx={{ fontWeight: 500 }}>
                            {name || user?.email || "Signed in"}
                        </Typography>
                        {name && (
                            <Typography variant="caption" color="text.secondary" noWrap component="div">
                                {user?.email}
                            </Typography>
                        )}
                    </Box>

                    <Divider />

                    {props.onHelp && (
                        <Button
                            fullWidth
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpen(false);
                                props.onHelp?.();
                            }}
                            startIcon={<HelpOutline fontSize="small" />}
                            sx={{ justifyContent: "flex-start", textTransform: "none", px: 2, py: 1, borderRadius: 0 }}
                        >
                            Shortcuts and tips
                        </Button>
                    )}

                    <Button
                        fullWidth
                        color="inherit"
                        size="small"
                        component={Link}
                        to="/api-tokens"
                        onClick={() => setOpen(false)}
                        startIcon={<Key fontSize="small" />}
                        sx={{ justifyContent: "flex-start", textTransform: "none", px: 2, py: 1, borderRadius: 0 }}
                    >
                        API tokens
                    </Button>

                    {/* full-page navigation: the server clears the auth cookies and redirects to "/" */}
                    <Button
                        fullWidth
                        color="inherit"
                        size="small"
                        href="/api/auth/logout"
                        startIcon={<Logout fontSize="small" />}
                        sx={{ justifyContent: "flex-start", textTransform: "none", px: 2, py: 1, borderRadius: 0 }}
                    >
                        Logout
                    </Button>
                </Box>
            </Popover>
        </>
    );
}
